import { Component } from "preact";
import { isNullOrUndefined } from "util";
import style from "./style";
import { logEvent } from "../../../../utils/logger";
import common from "../../../../utils/common";
import { numberWithCommas, numberWithoutCommas } from "../../../../utils/utility";

export default class DropdownAmountInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isError: false,
      errorName: "Value is required",
      inputValue: "",
      showDropDown: false,
      inputSelectedValue: ""
    };
    this.node = "";
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleDropdownClick = this.handleDropdownClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isError !== this.props.isError || nextProps.errorName !== this.props.errorName) {
      this.setState({ isError: nextProps.isError, errorName: nextProps.errorName });
    }
  }

  updateValue = (amt, name) => {
    if (name === this.props.name) {
      this.props.updateFormValue(this.props.index, "");
    } else {
      this.props.updateFormValue(this.props.index, name);
    }
    this.props.updateAmount(Number(numberWithoutCommas(amt)));
  };

  clearErrors = () => {
    if (this.state.isError && !isNullOrUndefined(this.props.index)) {
      this.props.clearErrorData(this.props.index);
    }
    logEvent({ eventType: "clicked_form_field", eventValue: "list form field", fieldName: this.props.name });
  };

  addCloseEvent() {
    document.addEventListener("click", this.handleOutsideClick, false);
  }

  removeCloseEvent() {
    document.removeEventListener("click", this.handleOutsideClick, false);
  }

  toggleDropDown = () => {
    this.setState(prevState => ({ showDropDown: !prevState.showDropDown }));
  };

  shouldComponentUpdate(nextProps, nextSate) {
    if (
      nextProps.inputValue == this.props.inputValue &&
      nextProps.isError == this.props.isError &&
      nextProps.errorName == this.props.errorName &&
      this.state.showDropDown == nextSate.showDropDown
    ) {
      return false;
    }
  }

  handleOutsideClick(e) {
    if (this.node.contains(e.target)) {
      return;
    }
    this.removeCloseEvent();
    this.handleDropdownClick(e, true);
  }

  handleDropdownClick(e, clickOutside = false) {
    if (clickOutside) {
      this.setState({ showDropDown: false });
      return;
    }
    if (!this.state.showDropDown) {
      this.addCloseEvent();
    } else {
      this.removeCloseEvent();
    }
    if (!clickOutside) {
      this.clearErrors();
    }
    this.toggleDropDown();
  }

  setAmountField = (name, value) => {
    const amt = numberWithCommas(value);
    this.state.inputValue && this.props.updateAmount(-Number(numberWithoutCommas(this.state.inputValue)));
    this.setState({ inputSelectedValue: `${name} - ₹${value}`, inputValue: amt });
    this.updateValue(amt, name);
  };

  updateSelected = (name, value) => {
    this.setAmountField(name, value);
    this.toggleDropDown();
  };

  getOption = options => {
    return options.map(({ name, value }) => (
      <li
        className={`${style["select-item"]} ${style["list-option"]}`}
        onClick={() => {
          this.updateSelected(name, value);
        }}
      >
        <span className={`${style["select-txt"]}`}>{`${name}${value ? " - ₹" : ""}${value}`}</span>
      </li>
    ));
  };

  componentWillUnmount() {
    document.removeEventListener("click", this.handleOutsideClick, false);
  }

  render({ name, constraints, placeholder, subText }, { inputSelectedValue, inputValue }) {
    return (
      <div className="pos-r mt10">
        <div
          ref={node => {
            this.node = node;
          }}
        >
          <div className={`${style["select-head"]}`} onClick={this.handleDropdownClick}>
            {placeholder && !this.state.inputValue && <span className={`${style["select-para"]}`}>{placeholder}</span>}
            {!isNullOrUndefined(inputValue) && inputValue.length > 0 && (
              <span className={`${style["value-added"]}`}>{inputSelectedValue}</span>
            )}
            <span className={`${style["drop-link"]}`}>
              <img src={`${common.getStaticPath()}/assets/ic-chevron-down.svg`} />
            </span>
          </div>
          <div className={`${style["select-dropdown"]} ${this.state.showDropDown ? style.visible : ""}`}>
            <ul className={`${style["select-list"]}`}>{this.getOption(constraints.allowedValues)}</ul>
          </div>
        </div>
        {subText && <p className="input-info">{subText}</p>}
        {this.state.isError && (
          <span className={`error ${subText ? "sub-txt-err" : ""}`} data-error-for={name}>
            {this.state.errorName}
          </span>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./form/components/inputs/dropdown-amount/index.js